import { styled } from "styled-components";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import niddle from "../../../../assets/images/niddle.png";
import niddleCenter from "../../../../assets/images/niddleCenter.png";
ChartJS.register(ArcElement, Tooltip, Legend);

const Main = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
`;

const ChartContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const CenterImage = styled.img`
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: ${(props) => `translateX(-50%) rotate(${props.rotation}deg)`};
  transform-origin: center bottom;
  width: 20px;
  height: 100px;
  z-index: 1;
`;

export default function AssetDoughnutChart({ diversityScore }) {
  // 0-200 점수를 -90도에서 90도 사이의 각도로 변환
  const calculateRotation = (score) => {
    return -90 + (score / 200) * 180;
  };

  // 전체 점수를 구간별로 나누기
  const createSegmentData = (score) => {
    const segments = [];
    const total = 200;

    // 0-67: 빨강
    segments.push(Math.min(67, score));
    // 67-134: 주황
    segments.push(Math.min(67, Math.max(0, score - 67)));
    // 134-200: 파랑
    segments.push(Math.min(66, Math.max(0, score - 134)));
    // 남은 빈 공간
    segments.push(total - score);

    return segments;
  };

  const Data = {
    labels: ["0-67", "68-134", "135-200", "남은 구간"],
    datasets: [
      {
        data: createSegmentData(diversityScore),
        backgroundColor: ["#5C647D", "#2F3958", "#030E33", "#dedede"],
        borderColor: ["#5C647D", "#2F3958", "#030E33", "#dedede"],
        circumference: 180,
        rotation: 270,
      },
    ],
  };

  const Options = {
    cutout: "68%",
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
  };

  return (
    <div className="groupDiversityChart">
      <ChartContainer>
        <Doughnut data={Data} options={Options}></Doughnut>
        <CenterImage
          src={niddle}
          alt="center icon"
          rotation={calculateRotation(diversityScore)}
        />
      </ChartContainer>

      <div className="balance-degree groupDiversityChartBottom">
        {diversityScore.toFixed(0)}
      </div>
    </div>
  );
}
